/**
 * this is the left menu for the dashboard
 *
 * Created by Tom on 24/5/17
 */

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import cx from 'classnames'

import config from '../../config'

// action import
import {ActionCreator} from '../../actions/'

// component import
import Avatar from '../Avatar/'
import MenuItem from '../MenuItem/'
import AppLink from '../AppLink'
import AppButton from '../AppButton/'
import Footer from '../../components/Footer/'

// menu items import
import menuItems from './menuItems'
import topbarMenuItems from '../TopBar/menuItems'

// icon imports
import CloseIcon from '../../assets/svg/close.svg'

// style import
import './style.scss'

class LeftMenu extends Component {

    _onMenuClick() {
        const {setOpenLeftMenu, breakPointObj} = this.props

        //close the left menu on clicking menu item in mobile and tablet
        breakPointObj.lessThan.large && setOpenLeftMenu(false)
    }

    _closeClick() {
        const {setOpenLeftMenu} = this.props
        // close the left menu
        setOpenLeftMenu(false)
    }

    _signOutClick() {
        const {setOpenLeftMenu, breakPointObj} = this.props

        //close the left menu on clicking sign out button in mobile and tablet
        breakPointObj.lessThan.large && setOpenLeftMenu(false)
    }

    render() {

        const {openLeftMenu, breakPointObj, pathname} = this.props

        // switch on/off classes based on the truthy value 'openLeftMenu'
        const dynClass = cx('menu left-menu', {'left-menu--open': openLeftMenu})

        return (
            <div className={dynClass}>

                <div className="left-menu__wrapper">

                    {/* close icon (only tablet and mobile view) */}
                    <img
                        src={CloseIcon}
                        className="left-menu__close-icon"
                        alt="Left menu close icon"
                        onClick={::this._closeClick}/>

                    {/* avatar component */}
                    <Avatar
                        pathname={pathname}
                    />

                    {/* creating menu items from array */}
                    <div className="left-menu__menu-items">
                        {
                            menuItems.map((item, index) =>
                                <MenuItem
                                    key={index}
                                    svgIcon={item.menuIcon}
                                    isExternal={item.isExternal}
                                    openInNewTab={item.openInNewTab}
                                    menuText={item.menuText}
                                    route={item.route}
                                    pathname={pathname}
                                    onClick={() => ::this._onMenuClick()}
                                />
                            )
                        }
                    </div>

                    {/* creating top menu items from array (only show on table and mobile)*/}
                    {
                        ((breakPointObj.lessThan.medium || breakPointObj.lessThan.large) &&
                            <div className="left-menu__top-menu-items">

                                {
                                    topbarMenuItems.map((item, index) =>
                                        // don't display the sign-out item (index 4)
                                        index < 4
                                            ?
                                            <MenuItem
                                                key={index}
                                                svgIcon={item.menuIcon}
                                                isExternal={item.isExternal}
                                                openInNewTab={item.openInNewTab}
                                                menuText={item.menuText}
                                                route={item.route}
                                                pathname={pathname}
                                                onClick={() => ::this._onMenuClick(item)}/>
                                            :
                                            null
                                    )
                                }

                                {/* sign out button */}
                                <div className="left-menu__sign-out-button">
                                    <AppLink
                                        isExternal={true}
                                        route={config.endpoints.websiteSignOutURL}
                                    >
                                    <AppButton
                                        buttonText="SIGN OUT"
                                        onClick={::this._signOutClick}
                                        size="big"
                                        color="blue"/>
                                    </AppLink>
                                </div>

                            </div>)
                    }

                    {/* include footer (only show on desktop)*/}
                    {
                        (breakPointObj.greaterThan.medium && <Footer/>)
                    }

                </div>
            </div>
        )
    }
}

// define the prop types
LeftMenu.propTypes = {
    setOpenLeftMenu: PropTypes.func.isRequired,
    openLeftMenu: PropTypes.bool,
    breakPointObj: PropTypes.object,
    pathname: PropTypes.string
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        openLeftMenu: state.componentState.openLeftMenu,
        breakPointObj: state.browser,
        pathname: state.router.location.pathname,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenLeftMenu: action.setOpenLeftMenu
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenu)



// WEBPACK FOOTER //
// ./src/components/LeftMenu/index.js